/**
 * A plain data model simply requires specification of an id, so that the model
 * can be uniquely identified.
 */
export abstract class Model {
    /**
     * A unique id for the model given as either a string or a number.
     */
    public abstract readonly id: string | number;
}
